<template>
  <div id="app" :class="this.$store.getters.focusClass">
    <headerAtos></headerAtos>
    <router-view />   
    <footerAtos></footerAtos>
  </div>
</template>

<script>
import headerAtos from "./components/HeaderAtos.vue";
import footerAtos from "./components/FooterAtos.vue";
import { mapGetters } from "vuex";
import store from "@/store"

  export default {

      components: { 
        headerAtos,
        footerAtos
      }, 
      computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
          user: "user"
        })
      },
     
    
  }
</script>

<style lang="scss">
/*App vue css*/ 
body{
      margin: 0;
      font-family: 'Roboto', sans-serif;
      color: #000;
      font-size: 15px;
      height:100%;
      padding:0;
  }


  #app{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height:100%;
    position:relative;  
    background-color: #fff !important; 
  }
  a{
    text-decoration: none !important;
    &:hover{
        text-decoration: none !important;
    }
}
    .act-options {
        display: flex;
        gap: 15px;
        font-size: 14px;
        .md-ripple { display: none !important; }
        label {
          padding-left: 10px !important;
        }
    }

  .mx-calendar-content {
        table, th, td, tr {
          border: 1px solid #E0E0E0 !important;
        }
    }

</style>
